import { Suspense, useState } from 'react';

import {
  AddPaymentMethodForm,
  AddPaymentMethodFormSkeleton,
} from './AddPaymentMethodForm/AddPaymentMethodForm';
import { Button } from '../../../components/Button/Button';
import { Card } from '../../../components/Card/Card';
import { WhiteLabelOverride } from '../../../components/WhiteLabelOverride/WhiteLabelOverride';

export const AddPaymentMethod = () => {
  const [showAddPaymentMethodForm, setShowAddPaymentMethodForm] =
    useState(false);

  return (
    <Card title="Set up automatic payments today">
      <p>Add a debit card now to make your monthly payments automatically.</p>

      <div>
        {showAddPaymentMethodForm ? (
          <Suspense fallback={<AddPaymentMethodFormSkeleton />}>
            <AddPaymentMethodForm />
          </Suspense>
        ) : (
          <WhiteLabelOverride componentType="button" disabled={false}>
            <Button
              onClick={() => setShowAddPaymentMethodForm(true)}
              className="sm:w-full"
            >
              Add debit card now
            </Button>
          </WhiteLabelOverride>
        )}
      </div>
    </Card>
  );
};
